import { useEffect } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { useRouter } from "next/router";
import * as Sentry from "@sentry/node";
import { fetchAccountParams } from "main/javascripts/slices/accountParamSlice";
import { LINE_LIFF_SDK_URL } from "main/javascripts/constants/Constants";
import {
  setIsLIFFInitialized,
  // setIsFacebookMessengerInitialized,
  setIsLIFFLoggedIn,
} from "main/javascripts/slices/currentUserSlice";

// useAccountのredux toolkit版
// liff.initをここですると、同一ページでLiffTypesが違うところから来ると不整合が出るのでしない。必要なところでinitする
export const useUserAccount: any = (
  store: any,
  enableSocialSignedInCheck = false
): any => {
  const router = useRouter();
  const loadAccount = () => {
    return store
      .dispatch(fetchAccountParams({ param: "" }))
      .then(unwrapResult)
      .then((result) => {
        const accountParams = result;
        if (accountParams) {
          // 取得したデータを各reducerで直接保存しているため
          // 以前のinitCurrentUser/initAccountParamsは不要

          if (enableSocialSignedInCheck) {
            checkInitializedSocial(accountParams.facebookAppId);
          }
        }
      });
  };

  const checkLIFFState = () => {
    try {
      const context = liff?.getOS();
      if (context) {
        store.dispatch(setIsLIFFInitialized(true));
      }
      if (liff.id && liff.isLoggedIn()) {
        store.dispatch(setIsLIFFLoggedIn(true));
      }
    } catch {
      // do nothing
    }
  };

  const onLoadScriptLIFF = () => {
    checkLIFFState();
  };

  const loadScript = (url: string, onload?: any): void => {
    const script: HTMLScriptElement = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = onload ? onload : null;
    document.body.appendChild(script);
  };

  const checkInitializedSocial = (facebookAppId: string) => {
    if (typeof liff !== "undefined") {
      checkLIFFState();
    } else {
      loadScript(LINE_LIFF_SDK_URL, onLoadScriptLIFF);
    }
    // FacebookMessengerは現在使用していない
    if (facebookAppId) {
      //   (window as any).MessengerExtensions?.getContext(
      //     facebookAppId,
      //     (): void => {
      //       store.dispatch(setIsFacebookMessengerInitialized(true));
      //     },
      //     (err: any): void => {
      //       console.log("FBM ERROR ", err);
      //     }
      //   );
    }
  };

  useEffect(() => {
    if (router.isReady) {
      loadAccount().catch((e) => {
        console.error(e);
        if (process.env.SENTRY_DSN) {
          Sentry.captureException(e.errorMessages || e);
        }
      });
    }
  }, [router.isReady]);

  return;
};
